import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

interface Admin {
  _id: string
  name?: string
  email?: string
}

export function AssigneeCombobox({
  value,
  onChange,
}: {
  value: string | null
  onChange: (id: string | null) => void
}) {
  const { data, isLoading } = useQuery({
    queryKey: ['support-tickets', 'admins'],
    queryFn: () => api<{ data: Admin[] }>('/support-tickets/admins'),
  })

  return (
    <select
      className="h-7 w-full rounded border border-input bg-background px-2 text-xs"
      disabled={isLoading}
      value={value ?? ''}
      onChange={e => onChange(e.target.value || null)}
    >
      <option value="">Unassigned</option>
      {data?.data.map(a => (
        <option key={a._id} value={a._id}>
          {a.name ?? a.email ?? a._id}
        </option>
      ))}
    </select>
  )
}
